// extracted by mini-css-extract-plugin
export default {"container":"_Y-z","heading":"aZ-z","links":"bZ-z","copy":"cZ-z","subCopy":"dZ-z","linksLeft":"eZ-z","linksCenter":"fZ-z","linksRight":"gZ-z","link":"hZ-z","onlyLink":"iZ-z"};